export class Step10 {
    constructor() {}

    intitule = 'stepper.form.mapa_in.step9';
    getreceptcandidatures = 'form.mapa_in.getreceptcandidatures';
    getreceptoffres = 'form.mapa_in.getreceptoffres';
    getenvoiinvitation = 'form.mapa_in.getenvoiinvitation';
    getvalidite = 'form.mapa_in.getvalidite';
    getnbjoursvalidite = 'form.mapa_in.getnbjoursvalidite';
    getnbmoisvalidite = 'form.mapa_in.getnbmoisvalidite';
    getdatejusquauvalidite = 'form.mapa_in.getdatejusquauvalidite';
    getjusquauvalidite = 'form.mapa_in.getjusquauvalidite';
    getdureevalidite = 'form.mapa_in.getdureevalidite';

}
